<template>
  <div>
    <page-title-bar></page-title-bar>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap>
        <app-card :fullBlock="true" colClasses="xs12">
          <v-container>
            <v-layout row wrap px-3>
              <v-flex xs12>
                <router-link to="/delivery-companies">
                  <i class="zmdi zmdi-long-arrow-left zmdi-hc-2x"></i>
                </router-link>
              </v-flex>
            </v-layout>

            <v-layout row wrap px-3>
              <v-flex xs12>
                <h3>{{ $t('message.ownerName') }}</h3>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :label="$t('message.name')" v-model="user.name" readonly></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :label="$t('message.lastname')" v-model="user.lastname" readonly></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :label="$t('message.email')" v-model="user.email" readonly></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap px-3>
              <v-flex xs12>
                <h3>{{ $t('message.storeInformation')}}</h3>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field :label="$t('message.name')" v-model="user.company.name" readonly></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  :label="$t('message.description')"
                  v-model="user.company.description"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  :label="$t('message.telegramUser')"
                  v-model="user.company.telegram_user_bot"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  :label="$t('message.primaryUserAdministrator')"
                  v-model="user.company.admin_telegram_user"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  :label="$t('message.telephone')"
                  v-model="user.company.phone"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-layout row wrap px-3>
                <v-flex xs12>
                  <h3>{{ $t('message.address')}}</h3>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    :label="$t('message.country')"
                    v-model="user.company.country"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field :label="$t('message.state')" v-model="user.company.state" readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field :label="$t('message.city')" v-model="user.company.city" readonly></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </app-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { GET_USER } from "../../store/modules/users/actions.type";

export default {
  data() {
    return {
      user: {
        name: "",
        lastname: "",
        email: "",
        company: {
          name: "",
          description: "",
          phone: "Por setear",
          admin_telegram_user: "Por setear",
          telegram_user_bot: "Por setear",
          country: "Por setear",
          state: "Por setear",
          city: "Por setear",
          street_address: "Por setear",
          created_at: "",
          subscription_finish_date: ""
        }
      }
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      const userId = this.$route.params.id;
      this.$store
        .dispatch(GET_USER, userId)
        .then(res => {
          let [user] = res;
          this.user = user;
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style>
</style>